// src/actions/galleryActions.js
import {
  FETCH_GALLERY_REQUEST,
  FETCH_GALLERY_SUCCESS,
  FETCH_GALLERY_FAILURE,
  CREATE_ARTWORK_REQUEST,
  CREATE_ARTWORK_SUCCESS,
  CREATE_ARTWORK_FAILURE,
  UPDATE_ARTWORK_REQUEST,
  UPDATE_ARTWORK_SUCCESS,
  UPDATE_ARTWORK_FAILURE,
  DELETE_ARTWORK_REQUEST,
  DELETE_ARTWORK_SUCCESS,
  DELETE_ARTWORK_FAILURE,
  SELECT_ARTWORK,
  CLEAR_SELECTED_ARTWORK,
} from "./types";

export const fetchGalleryRequest = (payload) => ({
  type: FETCH_GALLERY_REQUEST,
  payload,
});

export const fetchGallerySuccess = (artworks) => ({
  type: FETCH_GALLERY_SUCCESS,
  payload: artworks,
});

export const fetchGalleryFailure = (error) => ({
  type: FETCH_GALLERY_FAILURE,
  payload: error,
});

export const createArtworkRequest = (payload) => ({
  type: CREATE_ARTWORK_REQUEST,
  payload,
});

export const createArtworkSuccess = (artwork) => ({
  type: CREATE_ARTWORK_SUCCESS,
  payload: artwork,
});

export const createArtworkFailure = (error) => ({
  type: CREATE_ARTWORK_FAILURE,
  payload: error,
});

export const updateArtworkRequest = (payload) => ({
  type: UPDATE_ARTWORK_REQUEST,
  payload,
});

export const updateArtworkSuccess = (artwork) => ({
  type: UPDATE_ARTWORK_SUCCESS,
  payload: artwork,
});

export const updateArtworkFailure = (error) => ({
  type: UPDATE_ARTWORK_FAILURE,
  payload: error,
});

export const deleteArtworkRequest = (payload) => ({
  type: DELETE_ARTWORK_REQUEST,
  payload,
});

export const deleteArtworkSuccess = (entityId) => ({
  type: DELETE_ARTWORK_SUCCESS,
  payload: entityId,
});

export const deleteArtworkFailure = (error) => ({
  type: DELETE_ARTWORK_FAILURE,
  payload: error,
});

export const selectArtwork = (artwork) => ({
  type: SELECT_ARTWORK,
  payload: artwork,
});

export const clearSelectedArtwork = () => ({
  type: CLEAR_SELECTED_ARTWORK,
});
